import { Icon } from "../../components/BaseComponents/Icon";

export const CalendarIcon = (props) => (
	<Icon fill="none" viewBox="0 0 20 20" {...props}>
		<path
			d="M6 6.66667C6.4416 6.66667 6.8 6.36867 6.8 6V2.66667C6.8 2.298 6.4416 2 6 2C5.5584 2 5.2 2.298 5.2 2.66667V6C5.2 6.36867 5.5584 6.66667 6 6.66667Z"
			fill="url(#paint0_linear_15716_19372)"
		/>
		<path
			d="M17.3333 4.4H15.3333V5.68384C15.3333 6.3618 14.8807 6.99148 14.2253 7.10164C13.3907 7.24172 12.6667 6.58552 12.6667 5.76068V4.4H7.33333V5.68384C7.33333 6.3618 6.88067 6.99148 6.22533 7.10164C5.39067 7.24172 4.66667 6.58552 4.66667 5.76068V4.4H2.66667C2.29867 4.4 2 4.70464 2 5.08V17.32C2 17.6954 2.29867 18 2.66667 18H17.3333C17.7013 18 18 17.6954 18 17.32V5.08C18 4.70464 17.7013 4.4 17.3333 4.4ZM16.6667 16.64H3.33333V8.48H16.6667V16.64Z"
			fill="url(#paint1_linear_15716_19372)"
		/>
		<path
			d="M14 6.66667C14.4416 6.66667 14.8 6.36867 14.8 6V2.66667C14.8 2.298 14.4416 2 14 2C13.5584 2 13.2 2.298 13.2 2.66667V6C13.2 6.36867 13.5584 6.66667 14 6.66667Z"
			fill="url(#paint2_linear_15716_19372)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_15716_19372"
				x1="10"
				y1="2"
				x2="10"
				y2="18"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0756C0" />
				<stop offset="1" stopColor="#2F97F4" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_15716_19372"
				x1="10"
				y1="2"
				x2="10"
				y2="18"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0756C0" />
				<stop offset="1" stopColor="#2F97F4" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_15716_19372"
				x1="10"
				y1="2"
				x2="10"
				y2="18"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0756C0" />
				<stop offset="1" stopColor="#2F97F4" />
			</linearGradient>
		</defs>
	</Icon>
);
